// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OsGA","col":"styles_col__kt5n_","actions":"styles_actions__1v9I9","conflict":"styles_conflict__2Y23o"};